import React from 'react'
import { connect } from 'react-redux'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'
import { ProductInterface } from '@/types/Product'
import { ColorsMap } from '@/utils/Theme'
import { Text } from '@/components/Text'
import {
  BrandWrapper,
  Cross,
  DescriptionWrapper,
  ProductImageWrapper,
  ProductWrapper,
  SalePriceWrapper,
} from './ProductCardStyles'
import { StateInterface } from '@/types/State'
import ProductTags from './ProductTags'
import { formatPrice } from '@/utils/Helpers'
import { isNewerThan } from '@/utils/Helpers/Validate'

export interface ProductAreaProps {
  product: ProductInterface
  settings: StateInterface['settings']
}

const ProductCard: React.VFC<ProductAreaProps> = ({ product, settings }) => {
  let onSale = false
  let variant = product.variants[0]
  let lowestSalePrice

  product.variants.forEach((variantData) => {
    if (variantData.sale_price && (!lowestSalePrice || variantData.sale_price < lowestSalePrice)) {
      onSale = true
      variant = variantData
    }
  })

  return (
    <Link href={`/product/${product.slug}`} passHref>
      <ProductWrapper>
        <ProductTags sale={onSale} recent={isNewerThan(new Date(product.created_at), 20)} />
        <BrandWrapper>
          <img src={product.brand.logo} alt={product.brand.name} />
        </BrandWrapper>
        <ProductImageWrapper>
          <img
            draggable={false}
            src={product.images[0] ? product.images[0].url : 'http://placehold.jp/250x250.png'}
            alt={product.images[0] ? product.images[0].alt : ''}
          />
        </ProductImageWrapper>

        <DescriptionWrapper>
          <Text textColor={ColorsMap.primary} fontSize="l" fontWeight="bold" title={product.name}>
            {product.name}
          </Text>
          <Text textColor={ColorsMap.brownishGrey} fontSize="m" fontWeight="normal" mb="0.5rem">
            {product.brand.name}
          </Text>
          {onSale ? (
            <SalePriceWrapper>
              <Cross>
                <Text textColor="textDefault" fontSize="l" my="auto">
                  {formatPrice(variant.price, settings.currency.symbol)}
                </Text>
              </Cross>
              <Text textColor="primary" fontSize="l" fontWeight="bold" mx="1.5rem">
                {formatPrice(variant.sale_price, settings.currency.symbol)}
              </Text>
            </SalePriceWrapper>
          ) : (
            <Text textColor={ColorsMap.primary} fontSize="l" fontWeight="bold">
              {formatPrice(product.variants[0].price, settings.currency.symbol)}
            </Text>
          )}
        </DescriptionWrapper>
      </ProductWrapper>
    </Link>
  )
}

const mapStateToProps = (state: StateInterface) => ({
  settings: state.settings,
})

export default connect(mapStateToProps)(ProductCard)
